"use client"

import { IconEye, IconEyeOff } from "@tabler/icons-react"
import { ComponentProps, forwardRef, useState } from "react"

import { Input } from "./Input"

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface Props extends ComponentProps<typeof Input> {}

const PasswordInput = forwardRef<HTMLInputElement, Props>((props, ref) => {
  const [isPasswordHidden, setIsPasswordHidden] = useState(true)

  return (
    <Input
      {...props}
      ref={ref}
      type={isPasswordHidden ? "password" : "text"}
      rightContent={
        <button
          type="button"
          className="focus-visible:ring-instacover-400 block rounded-md p-1 focus-visible:ring-1 focus-visible:outline-hidden"
          onClick={() => setIsPasswordHidden((h) => !h)}
        >
          {isPasswordHidden ? (
            <IconEye className="text-slate-400" size={20} />
          ) : (
            <IconEyeOff className="text-slate-400" size={20} />
          )}
        </button>
      }
    />
  )
})

PasswordInput.displayName = "PasswordInput"

export { PasswordInput }
